import { getLinkForAllCollections } from './pages/allCollections';
import { getLinkForAllShares } from './pages/allShares';
import { getLinkForAuthenticating } from './pages/authenticating';
import { getLinkForC2CConnections } from './pages/c2cConnections';
import { getLinkForCollection } from './pages/collection';
import { getLinkForFinder } from './pages/finder';
import { getLinkForFolder } from './pages/folder';
import { getLinkForFolderViewer } from './pages/folderViewer';
import { getLinkForInbox } from './pages/inbox';
import { getLinkForLogout } from './pages/logout';
import { getLinkForPair } from './pages/pair';
import { getLinkForPrint } from './pages/print';
import { getLinkForProject } from './pages/project';
import { getLinkForPromotions } from './pages/promotions';
import { getLinkForSearch } from './pages/search';
import { getLinkForSequences } from './pages/sequences';
import { getLinkForSettings } from './pages/settings';
import { getLinkForShareBuilder } from './pages/shareBuilder';
import { getLinkForShareReview } from './pages/shareReview';
import { getLinkForShareReviewReel } from './pages/shareReviewReel';
import { getLinkForTrashFolder } from './pages/trash';
import { getLinkForUnauthenticated } from './pages/unauthenticated';
import { getLinkForUploadLinkPublic } from './pages/uploadLinkPublic';
import { getLinkForUploadLinks } from './pages/uploadLinks';
import { getLinkForWorkspaces } from './pages/workspaces';
import type { GetLinkParams, ValidHref } from './types';

export const getLink = (params: GetLinkParams): ValidHref => {
  if (params.page === 'shareBuilderViewer')
    return getLinkForShareBuilder(params);
  if (params.page === 'shareBuilder') return getLinkForShareBuilder(params);
  if (params.page === 'c2cConnections') return getLinkForC2CConnections(params);
  if (params.page === 'allCollections') return getLinkForAllCollections(params);
  if (params.page === 'collectionViewer') return getLinkForCollection(params);
  if (params.page === 'collection') return getLinkForCollection(params);
  if (params.page === 'folder') return getLinkForFolder(params);
  if (params.page === 'folderViewer') return getLinkForFolderViewer(params);
  if (params.page === 'inbox') return getLinkForInbox(params);
  if (params.page === 'logout') return getLinkForLogout(params);
  if (params.page === 'trash') return getLinkForTrashFolder(params);
  if (params.page === 'allShares') return getLinkForAllShares(params);
  if (params.page === 'shareReview') return getLinkForShareReview(params);
  if (params.page === 'shareReviewFinder') return getLinkForShareReview(params);
  if (params.page === 'finder') return getLinkForFinder(params);
  if (params.page === 'unauthenticated')
    return getLinkForUnauthenticated(params);
  if (params.page === 'authenticating') return getLinkForAuthenticating(params);
  if (params.page === 'shareReviewReel')
    return getLinkForShareReviewReel(params);
  if (params.page === 'workspaces') return getLinkForWorkspaces(params);
  if (params.page === 'settings') return getLinkForSettings(params);
  if (params.page === 'print') return getLinkForPrint(params);
  if (params.page === 'promotions') return getLinkForPromotions(params);
  if (params.page === 'pair') return getLinkForPair(params);
  if (params.page === 'sequences') return getLinkForSequences(params);
  if (params.page === 'project') return getLinkForProject(params);
  if (params.page === 'search') return getLinkForSearch(params);
  if (params.page === 'uploadLinks') return getLinkForUploadLinks(params);
  if (params.page === 'uploadLinkPublic')
    return getLinkForUploadLinkPublic(params);

  // More coming soon!

  // eslint-disable-next-line
  throw new Error(`Unsupported page "${params['page']}"`);
};
